/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  // Divider,
  Typography,
  Link,
  Button,
  Tabs,
  Tab,
  Card,
  CardContent,
  Popover,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Divider,
  CircularProgress,
  Backdrop,
} from "@mui/material";
import React, { useEffect, useState } from "react";
// import { useLocation } from "react-router-dom";
import ChevronLeftOutlinedIcon from "@mui/icons-material/ChevronLeftOutlined";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import PersonIcon from "@mui/icons-material/Person";
import { useNavigate } from "react-router-dom";
import DeleteConfirmationDialog from "../../components/Composables/DeleteDialogs";
import API from "../../Utils/Interceptor/ApiMiddleware";
import CustomSnackbar from "../../components/Composables/CustomSnackBarMenu";
import LoadingSpinner from "../../components/Composables/CircularProgressBar";
import { useParams } from "react-router-dom";
import AddToJob from "../../components/Composables/AddToJob";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import DynamicDataGrid from "../../components/Composables/DynamicDataGrid";

function CandidateDescription() {
  const [hoverBackButton, setHoverBackButton] = useState(false);
  const [dialog, setDialog] = useState(false);
  const [addDialog, setAddDialog] = useState(false);
  const [candidateData, setCandidateData] = useState([]);
  const { id } = useParams();
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState("CandidateInfo");
  const [loading, setLoading] = useState({
    all: false,
    grid: false,
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "error",
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [activitiesData, setActivitiesData] = useState({
    activityData: [],
    paginationModel: {
      pageSize: 25,
      page: 0,
    },
    totalRows: 0,
  });
  const [regarding, setRegarding] = useState("");
  const [enteredBy, setEnteredBy] = useState("");
  const [type, setType] = useState("");
  const [filterOptions, setFilterOptions] = useState({
    regarding: [],
    enteredBy: [],
    type: [],
  });
  const [filtersLoading, setFiltersLoading] = useState(false);

  useEffect(() => {
    if (tabValue === "Activities") {
      fetchCandidateActivity(
        regarding,
        enteredBy,
        type,
        activitiesData.paginationModel.pageSize,
        activitiesData.paginationModel.page
      );
    }
  }, [activitiesData.paginationModel]);

  const handleFilterClick = (event) => {
    if (!filterOptions.regarding.length > 0) {
      fetchFilters();
    }
    setRegarding(localStorage.getItem("regarding"));
    setEnteredBy(localStorage.getItem("enteredBy"));
    setType(localStorage.getItem("type"));
    setAnchorEl(event.currentTarget);
  };

  const handleReset = () => {
    setRegarding("");
    setEnteredBy("");
    setType("");
    localStorage.setItem("regarding", "");
    localStorage.setItem("enteredBy", "");
    localStorage.setItem("type", "");
    setAnchorEl(null);
    setActivitiesData((prevState) => ({
      ...prevState,
      activityData: [],
    }));
    fetchCandidateActivity();
    fetchFilters();
  };

  const handleClose = () => {
    setAnchorEl(null);
    setRegarding("");
    setEnteredBy("");
    setType("");

    const isRegarding = localStorage.getItem("regarding");

    if (!isRegarding) {
      fetchFilters();
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    if (newValue === "Activities") {
      fetchCandidateActivity();
    }
  };

  const fetchCandidatesData = async () => {
    setLoading((prev) => ({
      ...prev,
      all: true,
    }));
    try {
      const response = await API.get(`/user/get-user-profile-details/${id}`);
      setCandidateData(response.data.data);
    } catch (error) {
      console.error("Error fetching candidate data:", error.message);
    } finally {
      setLoading((prev) => ({
        ...prev,
        all: false,
      }));
    }
  };
  const handleDeleteConfirmation = async (confirmed) => {
    setDialog(false);
    if (confirmed) {
      try {
        await deleteCandidateFunction();
      } catch (error) {
        console.error("Error deleting candidate:", error);
      }
    }
  };

  const handleSnackbarClose = () => setSnackbar({ ...snackbar, open: false });

  const deleteCandidateFunction = async () => {
    const payload = {
      user_id: id,
    };

    try {
      await API.post("/candidate/candidate-delete", payload);
      setSnackbar({
        open: true,
        message: "Candidate deleted successfully",
        severity: "success",
      });
      setTimeout(() => navigate(-1), 2000);
    } catch (error) {
      console.error("Error deleting Candidate:", error);
      // setSnackbar({
      //   open: true,
      //   message: "Error deleting Candidate",
      //   severity: "error",
      // })
    }
  };

  useEffect(() => {
    localStorage.setItem("regarding", "");
    localStorage.setItem("enteredBy", "");
    localStorage.setItem("type", "");
    fetchCandidatesData();
  }, []);

  const fetchCandidateActivity = async (
    joborder_id = 0,
    entered_by = 0,
    type = 0,
    limit = 25,
    offset = 0
  ) => {
    try {
      setLoading((prev) => ({
        ...prev,
        grid: true,
      }));
      const response = await API.get("/candidate/get-candidate-activity", {
        params: {
          candidate_id: id,
          joborder_id: joborder_id,
          entered_by: entered_by,
          type: type,
          limit: limit,
          offset: offset,
        },
      });

      const rawData = response.data?.data?.[0] || [];
      const totalRows = response.data?.data?.[1][0].totalActivities || [];

      const formatted = rawData.map((item, index) => ({
        id: index + 1,
        date: item.Date,
        type: item.Type,
        entered: item["Entered By"],
        regarding: item.Regarding,
        notes: item.Notes,
      }));
      setLoading((prev) => ({
        ...prev,
        grid: false,
      }));
      setActivitiesData((prevState) => ({
        ...prevState,
        activityData: formatted,
        totalRows: totalRows,
      }));
    } catch (error) {
      console.error("Error fetching candidate activities:", error);
    }
  };

  const fetchFilters = async (jobId = 0) => {
    try {
      setFiltersLoading(true);
      const res = await API.get(`/candidate/get-candidate-activity-filters`, {
        params: {
          candidate_id: id,
          joborder_id: jobId,
        },
      });

      const data = res.data?.data || [];

      // if (
      //   !data[0]?.length ||
      //   (Array.isArray(data[0]) &&
      //     data[0].length === 1 &&
      //     data[0][0]?.job_id === -1)
      // ) {
      //   setDisableLogActivity(true);
      // } else {
      //   setDisableLogActivity(false);
      // }

      if (
        Array.isArray(data[0]) &&
        Array.isArray(data[1]) &&
        Array.isArray(data[2])
      ) {
        setFilterOptions({
          regarding: data[0] || [],
          enteredBy: data[1] || [],
          type: data[2] || [],
        });
      } else if (Array.isArray(data[0])) {
        setFilterOptions((prev) => ({
          ...prev,
          enteredBy: data[0] || [],
        }));
      }
    } catch (err) {
      console.error("Error fetching candidate filters:", err);
    } finally {
      setFiltersLoading(false);
    }
  };

  return (
    <Box
      sx={{
        padding: "16px",
        backgroundColor: "#E3F2FD",
        height: "100%",
        borderRadius: "24px 0 0 0",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#FFF",
          borderRadius: "12px",
          padding: "16px",
          gap: "16px",
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {loading.all ? (
          <Box
            sx={{
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <LoadingSpinner />
          </Box>
        ) : (
          <>
            {/* Header Section  */}
            <Box
              sx={{
                display: "flex",
                borderBottom: "1px solid rgba(21, 29, 72, 0.12)",
                paddingBottom: "16px",
                gap: "12px",
                alignItems: "center",
                // alignItems: "center",
                // justifyContent: "space-between",
                // marginBottom: "16px",
              }}
            >
              {/* <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}> */}
              <Button
                startIcon={
                  <ChevronLeftOutlinedIcon
                    style={{ height: "16px", width: "16px" }}
                  />
                }
                onMouseEnter={() => setHoverBackButton(true)}
                onMouseLeave={() => setHoverBackButton(false)}
                sx={{
                  "& .MuiButton-startIcon": hoverBackButton
                    ? { marginRight: "4px !important" }
                    : {
                        margin: "0px",
                      },
                  padding: "4px",
                  backgroundColor: hoverBackButton ? "#3F95EA" : "#E7E7E7",
                  color: hoverBackButton ? "white" : "#1A1A1A",
                  height: "24px",
                  fontSize: 12,
                  textTransform: "none",
                  minWidth: hoverBackButton ? "12" : 24,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  "&:hover": {
                    backgroundColor: hoverBackButton ? "#3F95EA" : "#E7E7E7",
                  },
                }}
                onClick={() => navigate(-1)}
              >
                {hoverBackButton ? "Back" : ""}
              </Button>
              <Typography sx={{ fontSize: "22px", fontWeight: 600 }}>
                Candidate Description
              </Typography>
              {/* </Box> */}
            </Box>

            {/* <Divider sx={{ marginBottom: "20px" }} /> */}

            {/* Candidate Info Section  */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                // alignItems: "center",
                flexDirection: "row",
              }}
            >
              {/* Profile Section  */}
              <Box sx={{ display: "flex", gap: "16px", alignItems: "center" }}>
                <Box
                  sx={{
                    width: "100px",
                    height: "100px",
                    backgroundColor: "#E3F2FD",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <PersonIcon sx={{ fontSize: "100px", color: "#979797" }} />
                </Box>
                <Box>
                  <Typography fontSize={"20px"} fontWeight={600}>
                    {candidateData["Basic Details"]?.Name}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: "400",
                      color: "#00000099",
                    }}
                  >
                    {candidateData["Basic Details"] &&
                      Object.entries(candidateData["Basic Details"]).map(
                        ([key, value]) => {
                          if (key === "Created By") {
                            return (
                              <span key={key}>
                                {key} {value || "NA"}
                              </span>
                            );
                          }
                          return null;
                        }
                      )}
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: "400",
                      color: "#00000099",
                    }}
                  >
                    {candidateData?.["Basic Details"]?.["Current Address"]
                      ?.toLowerCase()
                      .includes("null")
                      ? "NA"
                      : candidateData?.["Basic Details"]?.["Current Address"] ||
                        "NA"}
                  </Typography>

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      marginTop: "8px",
                    }}
                  >
                    <MailOutlineIcon fontSize="small" color="primary" />
                    <Link
                      href={
                        candidateData["Basic Details"]?.Email
                          ? `mailto:${candidateData["Basic Details"].Email}`
                          : undefined
                      }
                      underline="none"
                      sx={{
                        color: "primary",
                        fontSize: "14px",
                        fontWeight: 400,
                      }}
                    >
                      {candidateData["Basic Details"]?.Email ||
                        "Email not available"}
                    </Link>
                  </Box>
                </Box>
              </Box>

              <Box sx={{ display: "flex", gap: "16px" }}>
                <Button
                  // startIcon={<EditOutlinedIcon />}
                  variant="contained"
                  color="primary"
                  sx={{ alignSelf: "flex-start" }}
                  onClick={() => setAddDialog(true)}
                >
                  <Typography sx={{ fontSize: "12px", fontWeight: "400" }}>
                    ADD TO JOB
                  </Typography>
                </Button>
                <Button
                  startIcon={<DeleteOutlineOutlinedIcon />}
                  variant="outlined"
                  color="error"
                  sx={{ alignSelf: "flex-start" }}
                  onClick={() => setDialog(true)}
                >
                  <Typography sx={{ fontSize: "12px", fontWeight: "400" }}>
                    DELETE
                  </Typography>
                </Button>
              </Box>
            </Box>
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.12)" }}
              sx={{ "& .MuiTabs-indicator": { height: "2px" } }}
            >
              <Tab
                value="CandidateInfo"
                label="CANDIDATE INFO"
                sx={{ fontWeight: "500", fontSize: "14px" }}
              />
              <Tab
                value="Resume"
                label="RESUME"
                sx={{ fontWeight: "500", fontSize: "14px" }}
              />
              <Tab
                value="Activities"
                label="ACTIVITIES"
                sx={{ fontWeight: "500", fontSize: "14px" }}
              />
            </Tabs>
            {tabValue === "CandidateInfo" && (
              <Box
                sx={{
                  display: "flex",
                  width: "100%",
                  gap: "16px",
                  height: "calc(100% - 250px)",
                }}
              >
                {Object.keys(candidateData).map((section) => (
                  <Card
                    key={section}
                    elevation={0}
                    sx={{
                      borderRadius: "4px",
                      border: "1px solid rgba(115, 119, 145, 0.08)",
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      maxHeight: "100%",
                      overflow: "hidden",
                    }}
                  >
                    <Box
                      sx={{
                        borderRadius: "4px 4px 0 0",
                        padding: "14px 20px",
                        backgroundColor: "rgba(63, 149, 234, 0.20)",
                        color: "#000",
                        fontSize: "14px",
                        fontWeight: "600",
                        flexShrink: 0,
                      }}
                    >
                      {section}
                    </Box>
                    <CardContent
                      sx={{
                        padding: "16px 20px",
                        overflowY: "auto",
                        flexGrow: 1,
                      }}
                    >
                      {Object.entries(candidateData[section]).map(
                        ([key, value]) => {
                          const isLinkField =
                            key.toLowerCase().includes("linkedin") ||
                            key.toLowerCase().includes("portfolio");
                          const displayValue =
                            value && (!Array.isArray(value) || value.length > 0)
                              ? Array.isArray(value)
                                ? value.join(", ")
                                : key.toLowerCase().includes("date")
                                ? new Date(value).toLocaleDateString("en-GB")
                                : value
                              : "NA";

                          return (
                            <Box
                              key={key}
                              sx={{
                                marginBottom: "8px",
                                gap: "20px",
                              }}
                              display={{ xs: "block", md: "block", lg: "flex" }}
                            >
                              <Typography
                                sx={{
                                  textTransform: "capitalize",
                                  fontWeight: "400",
                                  fontSize: "14px",
                                  color: "rgba(0, 0, 0, 0.60)",
                                  width: "150px",
                                  whiteSpace: "normal",
                                  wordBreak: "break-word",
                                }}
                              >
                                {key}
                              </Typography>

                              {isLinkField && displayValue !== "NA" ? (
                                <Link
                                  href={
                                    displayValue.includes("https")
                                      ? displayValue
                                      : `https://${displayValue}`
                                  }
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  width={{
                                    xs: "100%",
                                    md: "100%",
                                    lg: "calc(100% - 150px)",
                                  }}
                                  sx={{
                                    fontWeight: "400",
                                    fontSize: "14px",
                                    color: "blue",
                                    wordBreak: "break-word",
                                    textDecoration: "none",
                                  }}
                                >
                                  {displayValue.includes("https")
                                    ? displayValue.replace("https://", "")
                                    : displayValue}
                                </Link>
                              ) : (
                                <Typography
                                  width={{
                                    xs: "100%",
                                    md: "100%",
                                    lg: "calc(100% - 150px)",
                                  }}
                                  sx={{
                                    fontWeight: "400",
                                    fontSize: "14px",
                                    color: "rgba(0, 0, 0, 0.87)",
                                    whiteSpace: "normal",
                                    wordBreak: "break-word",
                                  }}
                                >
                                  {displayValue}
                                </Typography>
                              )}
                            </Box>
                          );
                        }
                      )}
                    </CardContent>
                  </Card>
                ))}
              </Box>
            )}
            {tabValue === "Resume" && (
              <Box
                sx={{
                  flex: 1,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {candidateData?.["Other Details"]?.Resume ? (
                  <iframe
                    src={
                      candidateData?.["Other Details"]?.Resume
                        ? candidateData["Other Details"].Resume.endsWith(".pdf")
                          ? candidateData["Other Details"].Resume
                          : `https://docs.google.com/gview?url=${encodeURIComponent(
                              candidateData["Other Details"].Resume
                            )}&embedded=true`
                        : ""
                    }
                    title="Candidate Resume"
                    width="100%"
                    height="100%"
                    style={{ border: "none", borderRadius: "8px" }}
                  />
                ) : (
                  <Typography
                    color="textSecondary"
                    fontSize={"14px"}
                    fontWeight={600}
                  >
                    No resume uploaded
                  </Typography>
                )}
              </Box>
            )}
            {tabValue === "Activities" && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  height: "calc(100% - 250px)",
                  overflow: "hidden",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    mb: 2,
                    flexShrink: 0,
                  }}
                >
                  <Button
                    startIcon={<FilterAltOutlinedIcon />}
                    variant="contained"
                    onClick={handleFilterClick}
                  >
                    Filter
                  </Button>
                  <Popover
                    open={Boolean(anchorEl)}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    disableRestoreFocus
                  >
                    {filtersLoading && (
                      <Backdrop
                        open
                        sx={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          zIndex: (theme) => theme.zIndex.drawer + 1,
                          backgroundColor: "rgba(255,255,255,0.7)",
                          color: "primary.main",
                        }}
                      >
                        <CircularProgress color="inherit" />
                      </Backdrop>
                    )}
                    <Box sx={{ padding: 2, width: 300 }}>
                      <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                        Activity Filter
                      </Typography>

                      <Divider sx={{ my: 1 }} />

                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                        }}
                      >
                        <Box>
                          <Typography sx={{ mb: 1, fontWeight: 500 }}>
                            Regarding
                          </Typography>
                          <FormControl size="small" fullWidth>
                            <InputLabel>Select</InputLabel>
                            <Select
                              value={regarding}
                              label="Select"
                              onChange={(e) => {
                                setRegarding(e.target.value);
                                setEnteredBy("");
                                fetchFilters(e.target.value);
                              }}
                            >
                              {filterOptions.regarding?.length > 0 ? (
                                filterOptions.regarding.map((opt) => (
                                  <MenuItem key={opt.job_id} value={opt.job_id}>
                                    {opt.title}
                                  </MenuItem>
                                ))
                              ) : (
                                <MenuItem disabled>No Jobs</MenuItem>
                              )}
                            </Select>
                          </FormControl>
                        </Box>

                        <Box>
                          <Typography sx={{ mb: 1, fontWeight: 500 }}>
                            Entered by
                          </Typography>
                          <FormControl size="small" fullWidth>
                            <InputLabel>Select Entered by</InputLabel>
                            <Select
                              value={enteredBy}
                              label="Select Entered by"
                              onChange={(e) => setEnteredBy(e.target.value)}
                            >
                              {filterOptions.enteredBy?.length > 0 ? (
                                filterOptions.enteredBy.map((opt) => (
                                  <MenuItem
                                    key={opt.user_id}
                                    value={opt.user_id}
                                  >
                                    {opt["Entered By"]}
                                  </MenuItem>
                                ))
                              ) : (
                                <MenuItem disabled>No Users</MenuItem>
                              )}
                            </Select>
                          </FormControl>
                        </Box>

                        <Box>
                          <Typography sx={{ mb: 1, fontWeight: 500 }}>
                            Type
                          </Typography>
                          <FormControl size="small" fullWidth>
                            <InputLabel>Select Type</InputLabel>
                            <Select
                              value={type}
                              label="Select Type"
                              onChange={(e) => setType(e.target.value)}
                            >
                              {filterOptions.type?.length > 0 ? (
                                filterOptions.type.map((opt) => (
                                  <MenuItem
                                    key={opt.activity_type_id}
                                    value={opt.activity_type_id}
                                  >
                                    {opt.short_description}
                                  </MenuItem>
                                ))
                              ) : (
                                <MenuItem disabled>No Types</MenuItem>
                              )}
                            </Select>
                          </FormControl>
                        </Box>
                      </Box>

                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "flex-end",
                          marginTop: 3,
                          gap: 1,
                        }}
                      >
                        <Button onClick={handleReset}>Reset</Button>
                        <Button
                          variant="contained"
                          onClick={() => {
                            setAnchorEl(null);
                            fetchCandidateActivity(regarding, enteredBy, type);
                            localStorage.setItem("regarding", regarding);
                            localStorage.setItem("enteredBy", enteredBy);
                            localStorage.setItem("type", type);
                          }}
                        >
                          Apply
                        </Button>
                      </Box>
                    </Box>
                  </Popover>
                </Box>
                <Box sx={{ flex: 1, overflow: "hidden" }}>
                  <DynamicDataGrid
                    rows={activitiesData.activityData}
                    loading={loading.grid}
                    paginationModel={activitiesData.paginationModel}
                    onPaginationModelChange={(paginationModel) => {
                      setActivitiesData((prevState) => ({
                        ...prevState,
                        paginationModel: paginationModel,
                      }));
                    }}
                    totalRows={activitiesData.totalRows}
                  />
                </Box>
              </Box>
            )}
          </>
        )}
      </Box>
      <DeleteConfirmationDialog
        open={dialog}
        onClose={() => setDialog(false)}
        onConfirm={handleDeleteConfirmation}
        pageName={"candidate"}
      />
      <CustomSnackbar
        open={snackbar.open}
        onClose={handleSnackbarClose}
        message={snackbar.message}
        severity={snackbar.severity}
      />
      <AddToJob
        open={addDialog}
        onClose={() => {
          setAddDialog(false);
          fetchFilters();
          if (tabValue === "Activities") {
            setActivitiesData((prevState) => ({
              ...prevState,
              activityData: [],
            }));
            fetchCandidateActivity(regarding, enteredBy, type);
          }
        }}
        candidateId={[Number(id)]}
        setSnackbar={setSnackbar}
      />
    </Box>
  );
}

export default CandidateDescription;
